// React Query
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

// Axios & Interceptors
import axios from "axios";
// Chart.js
import { Chart, registerables } from "chart.js";
import React from "react";
import { createRoot } from "react-dom/client";
// Toasts
import { ToastContainer } from "react-toastify";
import { setupAxios } from "./app/modules/auth"; // adjust a path if needed
import "react-toastify/dist/ReactToastify.css";

// Metronic
import { MetronicI18nProvider } from "./_metronic/i18n/Metronici18n";
import "./_metronic/assets/sass/style.react.scss";
import "./_metronic/assets/fonticon/fonticon.css";
import "./_metronic/assets/keenicons/duotone/style.css";
import "./_metronic/assets/keenicons/outline/style.css";
import "./_metronic/assets/keenicons/solid/style.css";
/**
 * TIP: Replace with RTL styles for RTL mode:
 * import './_metronic/assets/css/style.rtl.css'
 **/
import "./_metronic/assets/sass/style.scss";

import { AuthProvider } from "./app/modules/auth";
// App Routing & Auth
import { AppRoutes } from "./app/routing/AppRoutes";

// ----- Setup global services -----
setupAxios(axios);
Chart.register(...registerables);

// ----- Initialize React Query -----
const queryClient = new QueryClient();

// ----- Render Application -----
const container = document.getElementById("root");
if (container) {
	createRoot(container).render(
		<React.StrictMode>
			<QueryClientProvider client={queryClient}>
				<MetronicI18nProvider>
					<AuthProvider>
						<AppRoutes />
						<ToastContainer
							position="top-center"
							autoClose={10000}
							hideProgressBar={false}
							newestOnTop={false}
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
							limit={5}
						/>
					</AuthProvider>
				</MetronicI18nProvider>
				{import.meta.env.VITE_APP_ENV === "development" && (
					<ReactQueryDevtools initialIsOpen={false} />
				)}
			</QueryClientProvider>
		</React.StrictMode>,
	);
}
